import { useEffect, useState } from 'react';
import axios from 'axios';
export const urlMethods = { post: 'post', get: 'get' };

export const useApi = (config, initialData, shouldExecute) => {
  const [data, setData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsLoading(true);

      try {
        const result = await axios.request(config);
        setData(result.data);
      } catch (error) {
        setIsError(true);
      }

      setIsLoading(false);
    };

    if (shouldExecute) {
      fetchData();
    }
  }, [JSON.stringify(config), initialData, shouldExecute]);

  return [{ data, isLoading, isError }];
};
